import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';
import { processComparisonValue } from 'components/Catalog/ProductGrid/hooks/useComparisonSkus';
import EmptyState from 'components/Catalog/ProductGrid/CompareModal/EmptyState';

const SizesZone = ({ skus = [], getText = () => {} }) => {
    const renderContent = (sku, index) => {
        const valueData = processComparisonValue(
            sku,
            skuItem => skuItem.size,
            () => true // Always show if size exists
        );

        if (!valueData) {
            return <EmptyState />;
        }

        const hasSizeRefinement = sku?.sizeRefinement && sku.sizeRefinement !== null;

        const { currentValue: currentSize, additionalValues: additionalSizes } = valueData;

        return (
            <Box
                css={styles.sizeContent}
                role='group'
                aria-label={getText('productInformation', [index + 1])}
            >
                <Text
                    fontSize='sm'
                    color='gray'
                    lineHeight='none'
                    is='h3'
                >
                    {hasSizeRefinement ? `${sku.sizeRefinement} ${getText('size')}:` : getText('standardSize')}
                </Text>
                <Text is='p'>{currentSize}</Text>
                {additionalSizes > 0 && (
                    <Text
                        fontSize='sm'
                        color='gray'
                        is='p'
                    >
                        + {additionalSizes} {additionalSizes === 1 ? getText('size') : getText('sizes').toLowerCase()}
                    </Text>
                )}
            </Box>
        );
    };

    return (
        <CompareZoneBase
            skus={skus}
            getText={getText}
            titleKey='sizes'
            renderContent={renderContent}
        />
    );
};

const styles = {
    sizeContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
    }
};

SizesZone.propTypes = {
    skus: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(SizesZone, 'SizesZone');
